var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08 8C2.95 8 1.989 7.61 1.193 6.83.398 6.05 0 5.107 0 4c0-1.106.398-2.05 1.193-2.83C1.99.39 2.951 0 4.08 0h2.174a.87.87 0 0 1 .633.253.837.837 0 0 1 .259.621.837.837 0 0 1-.259.622.87.87 0 0 1-.633.253H4.08c-.638 0-1.18.219-1.627.656A2.15 2.15 0 0 0 1.783 4c0 .625.224 1.157.67 1.595.447.437.989.656 1.627.656h2.174a.87.87 0 0 1 .633.253.837.837 0 0 1 .259.622.837.837 0 0 1-.259.62.87.87 0 0 1-.633.254H4.08zm1.497-3.195A.803.803 0 0 1 4.756 4c0-.228.079-.42.236-.574a.803.803 0 0 1 .585-.231h4.846a.803.803 0 0 1 .821.805c0 .228-.079.42-.236.574a.803.803 0 0 1-.585.231H5.577zM9.747 8a.87.87 0 0 1-.634-.253.837.837 0 0 1-.259-.621c0-.246.086-.453.259-.622a.87.87 0 0 1 .633-.253h2.174c.638 0 1.18-.219 1.627-.656.446-.438.67-.97.67-1.595a2.15 2.15 0 0 0-.67-1.595 2.237 2.237 0 0 0-1.627-.656H9.746a.87.87 0 0 1-.633-.253.837.837 0 0 1-.259-.622c0-.245.086-.452.259-.62A.87.87 0 0 1 9.746 0h2.174c1.129 0 2.091.39 2.887 1.17C15.602 1.95 16 2.893 16 4c0 1.106-.398 2.05-1.193 2.83C14.01 7.61 13.049 8 11.92 8H9.746z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1dbaf8ac7943d69e4b18dff8f2102cad.svg";
export { ForwardRef as ReactComponent };